import React, { useRef, useEffect } from "react";
import { ThreeDots } from '../common/Placeholders.jsx';
import PropTypes from 'prop-types';

function YandexWidgetComponent({ payment }) {

  useEffect(() => {
    //Инициализация виджета. Все параметры обязательные.
    const checkout = new window.YandexCheckout({
      confirmation_token: payment.confirmation_token, //Токен, который перед проведением оплаты нужно получить от Яндекс.Кассы
      return_url: payment.return_url, //Ссылка на страницу завершения оплаты
      error_callback(error) {
        //Обработка ошибок инициализации
        console.log(error);
      }
    });
    checkout.render('payment-form_' + payment.id);
  }, []);

  return <div id={'payment-form_' + payment.id}></div>;
}

YandexWidgetComponent.propTypes = {
  payment: PropTypes.shape({
    id: PropTypes.number.isRequired,
    confirmation_token: PropTypes.string.isRequired,
    return_url: PropTypes.string.isRequired,
  }).isRequired,
  onBuyApprove: PropTypes.func.isRequired,
}

export default YandexWidgetComponent;